export const memberTermsIntro = {
  title: "Ketentuan Proses Operasional PUGAR",
  body: "Pusat Uang Gampang Anti Riba (PUGAR) PT Bhakti Insan Kamil adalah program atau pusat layanan internal yang bertujuan memberikan kemudahan akses terhadap solusi keuangan bagi karyawan maupun mitra perusahaan secara cepat, aman, transparan, dan bertanggung jawab, dengan tetap mengedepankan prinsip kepatuhan terhadap kebijakan perusahaan dan peraturan yang berlaku.",
};

export const memberTermsHighlights = [
  {
    title: "Pendaftaran",
    body: "Pendaftaran kepesertaan PUGAR bisa dilakukan setiap waktu melalui aplikasi atau web PUGAR.",
    icon: "fas fa-user-plus",
  },
  {
    title: "Pencairan pinjaman",
    body: "Pencairan pinjaman dijadwalkan setiap tanggal 1 dan 16 sesuai periode pengajuan.",
    icon: "fas fa-money-check-alt",
  },
  {
    title: "Pelunasan dipercepat",
    body: "Pelunasan dipercepat dapat diajukan tanggal 1 sampai 13 dengan upload bukti transfer.",
    icon: "fas fa-receipt",
  },
];

export const memberTermsSections = [
  {
    title: "Pendaftaran Kepesertaan PUGAR",
    icon: "fas fa-user-plus",
    items: [
      {
        title: "Syarat kepesertaan",
        body: [
          "Karyawan aktif minimal 3 bulan dan bekerja di PT Bhakti Insan Kamil.",
          "Status karyawan dibuktikan dengan Nopeg atau Nomor Pegawai.",
        ],
      },
      {
        title: "Cara pendaftaran",
        body: "Pendaftaran dapat dilakukan melalui aplikasi PUGAR atau web PUGAR.",
        links: [
          {
            label: "Download aplikasi PUGAR",
            url: "https://drive.google.com/file/d/1SMAyRjAuqrTYoBCqKF9imzK_326MzshW/view?usp=drivesdk",
          },
          {
            label: "Buka web PUGAR",
            url: "https://pugar.bhaktiinsangrup.net/member/auth/login",
          },
        ],
      },
      {
        title: "Email dan nomor HP",
        body: "Peserta wajib memiliki email dan nomor HP yang aktif.",
      },
      {
        title: "Waktu pendaftaran",
        body: "Pendaftaran PUGAR bisa dilakukan setiap waktu.",
      },
      {
        title: "Tabungan kepesertaan",
        body: "Tabungan kepesertaan PUGAR mulai dari Rp50.000 sampai Rp500.000.",
      },
    ],
  },
  {
    title: "Pengajuan Pinjaman PUGAR",
    icon: "fas fa-hand-holding-usd",
    items: [
      {
        title: "Kapan pinjaman bisa diajukan?",
        body: "Pinjaman PUGAR bisa diajukan setelah pendaftaran kepesertaan di-approve.",
      },
      {
        title: "Syarat pinjaman sebelumnya",
        body: "Pengajuan pinjaman akan diproses jika sisa pinjaman sebelumnya sudah dilakukan pelunasan atau top up sesuai ketentuan.",
      },
      {
        title: "Limit dan tenor",
        body: "Pinjaman disesuaikan dengan batas limit dan tenor yang telah ditentukan oleh layanan.",
      },
      {
        title: "Jadwal pencairan pinjaman",
        body: "Proses pencairan pinjaman dilakukan setiap tanggal 16 dan tanggal 1 setiap bulan.",
      },
      {
        title: "Periode pengajuan dan jadwal pencairan",
        body: [
          "Pengajuan tanggal 13 sampai 26 dijadwalkan cair tanggal 1.",
          "Pengajuan tanggal 27 sampai 12 dijadwalkan cair tanggal 16.",
        ],
      },
      {
        title: "Jadwal approval pinjaman",
        body: "Proses approval pinjaman dilakukan tanggal 13 dan tanggal 27.",
      },
    ],
  },
  {
    title: "Pelunasan Dipercepat",
    icon: "fas fa-file-invoice-dollar",
    items: [
      {
        title: "Periode pelunasan dipercepat",
        body: "Pelunasan dipercepat bisa dilakukan tanggal 1 sampai 13 dengan catatan peserta wajib upload bukti transfer pada aplikasi atau platform PUGAR.",
      },
      {
        title: "Pelunasan sebagian atau seluruhnya",
        body: "Pelunasan dipercepat bisa dilakukan sebagian atau seluruhnya.",
      },
      {
        title: "Top up pinjaman",
        body: "Jika karyawan mengajukan pinjaman baru dan pinjaman lama tersisa maksimal 2 kali angsuran, proses tersebut disebut top up.",
      },
      {
        title: "Jadwal approval pelunasan",
        body: "Proses approval pelunasan dipercepat dilakukan tanggal 13.",
      },
    ],
  },
  {
    title: "Up dan Down Perubahan Simpanan",
    icon: "fas fa-wallet",
    items: [
      {
        title: "Cara pengajuan perubahan simpanan",
        body: "Pengajuan perubahan simpanan bisa dilakukan pada aplikasi atau platform PUGAR.",
      },
      {
        title: "Batas perubahan simpanan",
        body: "Perubahan simpanan tidak bisa dilakukan setiap bulan. Perubahan simpanan akan dikunci dengan batas 3 bulan.",
      },
      {
        title: "Jadwal approval perubahan simpanan",
        body: [
          "Pengajuan tanggal 14 bulan sebelumnya sampai tanggal 13 bulan berjalan akan di-approve tanggal 14 bulan berjalan dan ikut pemotongan bulan berjalan.",
          "Pengajuan tanggal 14 bulan berjalan sampai tanggal 13 bulan berikutnya akan di-approve tanggal 14 bulan berikutnya dan ikut pemotongan bulan selanjutnya.",
        ],
      },
    ],
  },
  {
    title: "Keluar Kepesertaan PUGAR",
    icon: "fas fa-door-open",
    items: [
      {
        title: "Form pengajuan keluar kepesertaan",
        body: "Pengajuan keluar kepesertaan PUGAR dapat dilakukan dengan mengisi form pengajuan keluar. Pengisian form wajib menggunakan tulisan dan tanda tangan basah.",
        links: [
          {
            label: "Download form keluar kepesertaan",
            url: "https://drive.google.com/file/d/1sIeoRK48ZC4q96WWrPXHwfoJ9JIw2s9i/view?usp=sharing",
          },
        ],
      },
      {
        title: "Pengiriman form",
        body: "Form dapat dikirimkan melalui fitur Chat yang tersedia di website PUGAR, WA PUGAR, atau ke PIC masing-masing.",
        links: [
          {
            label: "Chat WA PUGAR",
            url: "https://wa.me/6285955332929",
          },
        ],
      },
      {
        title: "Pendaftaran ulang",
        body: "Karyawan yang keluar dari kepesertaan PUGAR tidak bisa melakukan pendaftaran ulang pada bulan berikutnya. Akses akan dikunci selama 3 bulan.",
      },
      {
        title: "Jadwal approval dan realisasi keluar kepesertaan",
        body: [
          "Pengajuan tanggal 26 sampai 12 akan di-approve tanggal 14 dan direalisasikan tanggal 16 bulan berjalan.",
          "Pengajuan tanggal 13 sampai 25 akan di-approve tanggal 27 dan direalisasikan tanggal 1 bulan selanjutnya.",
        ],
      },
    ],
  },
];
